// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"133":"98e5b003","178":"2346a78b","184":"26e50001","216":"3b9878c9","265":"09f6ffb7","440":"96b143e4","559":"e601f4b9","646":"25513b23","789":"a2f1f874","810":"abb99ca7"}[chunkId] + ".chunk.js";
};